import { render } from "./DeleteElementIcon.vue?vue&type=template&id=00f406ae&scoped=true&ts=true"
import script from "./DeleteElementIcon.vue?vue&type=script&lang=ts"
export * from "./DeleteElementIcon.vue?vue&type=script&lang=ts"

import "./DeleteElementIcon.vue?vue&type=style&index=0&id=00f406ae&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00f406ae"]])

export default __exports__